import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';
import { GetStaticPaths, GetStaticProps } from 'next';
import { GuideChapterPage } from '~/components/Guides';
import { GuidechapterItems } from '~/graphql/sdk';

import { enhancedStaticProps, withLayout, sdk as sdkClient } from '~/lib';

/** @TODO should be fully dynamic, see issue `WEB-62` */

export interface HeadlessGuideProps extends WithStoryProps {
  guideChapters: GuidechapterItems;
}

const HeadlessGuide = ({ story, guideChapters }: HeadlessGuideProps) => {
  return <GuideChapterPage story={story} guideChapters={guideChapters} />;
};

export default withLayout(withStory(HeadlessGuide));

export const getStaticProps: GetStaticProps = enhancedStaticProps(
  async ({ params: { name, slug }, sdk }) => {
    let story;
    let guideChapters;
    let notFound = false;

    try {
      story = (await sdk.guideChapterItem({ slug: `/guides/${name}/${slug}` }))
        .GuidechapterItem;
    } catch (e) {
      notFound = true;
    }

    try {
      guideChapters = (
        await sdk.guideChapterItems({ by_slugs: `guides/${name}/*` })
      ).GuidechapterItems;
    } catch (e) {
      notFound = true;
    }

    return {
      props: {
        story,
        guideChapters,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  },
);

export const getStaticPaths: GetStaticPaths = async () => {
  let stories;

  try {
    stories = (await sdkClient.guideChapterItems({ by_slugs: `guides/*/*` }))
      .GuidechapterItems.items;
  } catch (e) {
    console.log(e);
  }

  return {
    paths: stories?.map(({ full_slug, slug }) => ({
      params: {
        name: full_slug.replace(/^guides\//, '').replace(/\\${slug}$/, ''),
        slug,
      },
    })),
    fallback: 'blocking',
  };
};
